<template>
  <div class="overflow-x-auto scrollbar-hidden" v-if="dataArray.length>0">
    <DatatableProfile :data-array="dataArray" :data-array-table="dataArrayTable" :router-name="'family'" />
  </div>
</template>

<script>
import { defineComponent, ref, reactive, onMounted } from 'vue'
import DatatableProfile from "@/components/datatable/datatableProfile.vue"

export default defineComponent({
  components:{
    DatatableProfile
  },
  props:{
    dataArray:{
      type: Array
    }
  },
  setup() {
    var customNameMutator = (value, data, type, params, component) => {
      let fullname = "-"
      if(data.memberinfo ? data.memberinfo.head_member : false){
        fullname = `${data.memberinfo.head_member.title ? data.memberinfo.head_member.title : ""}${data.memberinfo.head_member.name ? data.memberinfo.head_member.name : ""} ${data.memberinfo.head_member.surname ? data.memberinfo.head_member.surname : ""}`
      }
      return fullname;
    }
    var customProblemMutator = (value, data, type, params, component) => {
      if(data.memberinfo ? data.memberinfo.member_stats : false){
        return {"housing": data.memberinfo.member_stats.prob_housing, "health": data.memberinfo.member_stats.prob_health, "occupation": data.memberinfo.member_stats.prob_occupation, "education": data.memberinfo.member_stats.prob_education, "accessibility": data.memberinfo.member_stats.prob_accessibility}
      }else{
        return {"housing": 0, "health": 0, "occupation": 0, "education": 0, "accessibility": 0}
      }
    }
    var customMemberCountMutator = (value, data, type, params, component) => {
      let result = ""
      if(data.memberinfo ? data.memberinfo.member_stats : false){
        return data.memberinfo.member_stats.member_cnt
      }
      return result
    }
    var customFamTypeMutator = (value, data, type, params, component) => {
      return data.fam_type ? data.fam_type.desc : null
    }
    const dataArrayTable = reactive([
      {title:"หัวหน้าครอบครัว", field:"full_name",minWidth: 200, mutator: customNameMutator, resizable:true, formatter:"textarea"},
      {title:"สภาพปัญหา", field:"problems", minWidth: 200, mutator: customProblemMutator, variableHeight: true, headerSort: false,
        formatter:function(cell, formatterParams){
          var value = cell.getValue();
          let res = `<div class="flex flex-wrap">\
                      <button class='t-tooltip btn btn-secondary mr-1 border-0 rounded-full w-8 h-8 p-2 mb-1 text-white hover:bg-theme-37 ${value.housing == 1 ?'bg-theme-36 hover:bg-theme-36':'bg-theme-37 hover:bg-theme-37'}'>\
                        <span class="t-tooltip-text">สุขภาพอนามัย</span>\
                        <span class="img-icon heart-icon"></span>\
                      </button>\
                      <button class='t-tooltip btn btn-secondary mr-1 border-0 rounded-full w-8 h-8 p-2 mb-1 text-white ${value.health == 1 ?'bg-theme-36 hover:bg-theme-36':'bg-theme-37 hover:bg-theme-37'}'>\
                        <span class="t-tooltip-text">ครอบครัว</span>\
                        <span class="img-icon home-icon"></span>\
                      </button>\
                      <button class='t-tooltip btn btn-secondary mr-1 border-0 rounded-full w-8 h-8 p-2 mb-1 text-white ${value.occupation == 1?'bg-theme-36 hover:bg-theme-36':'bg-theme-37 hover:bg-theme-37'}'>\
                        <span class="t-tooltip-text">การมีงานทำและมีรายได้</span>\
                        <span class="img-icon dollar-sign-icon"></span>\
                      </button>\
                      <button class='t-tooltip btn btn-secondary mr-1 border-0 rounded-full w-8 h-8 p-2 mb-1 text-white ${value.accessibility == 1 ?'bg-theme-36 hover:bg-theme-36':'bg-theme-37 hover:bg-theme-37'}'>\
                        <span class="t-tooltip-text">การเข้าไม่ถึงสิทธิและความเป็นธรรมในสังคม</span>\
                        <span class="img-icon card-icon"></span>\
                      </button>\
                      <button class='t-tooltip btn btn-secondary mr-1 rounded-full w-8 h-8 p-2 mb-1 text-white ${value.education == 1?'bg-theme-36 hover:bg-theme-36':'bg-theme-37 hover:bg-theme-37'}'>\
                        <span class="t-tooltip-text">การศึกษา</span>\
                        <span class="img-icon book-open-icon"></span>\
                      </button>\
                      </div>`
          return res
        }
      },
      {title:"ลักษณะครอบครัว", field:"fam_type", hozAlign:"center", minWidth: 200, resizable: true, mutator: customFamTypeMutator,
        formatter:function(cell, formatterParams){
          if(cell.getValue() == "ครอบครัวเดี่ยว (พ่อ แม่ ลูก)"){
            return "<button\
                class='btn btn-outline-secondary inline-block bg-white mr-1'\
              >\
              ครอบครัวเดี่ยว\
              </button>"
          }
          else if(cell.getValue() == "ครอบครัวข้ามรุ่น (ปู่ ย่า ตา ยาย อยู่กับหลานตามลำพัง)"){
            return "<button\
                class='btn btn-outline-secondary inline-block bg-white mr-1'\
              >\
              ครอบครัวข้ามรุ่น\
              </button>"
          }
          else if(cell.getValue() == "ครอบครัวพ่อหรือแม่เลี้ยงเดี่ยว"){
            return "<button\
                class='btn btn-outline-secondary inline-block bg-white mr-1'\
              >\
              ครอบครัวพ่อหรือแม่เลี้ยงเดี่ยว\
              </button>"
          }
          else if(cell.getValue() == "ครอบครัววัยรุ่น (อายุต่ำกว่า 20 ปี)"){
            return "<button\
                class='btn btn-outline-secondary inline-block bg-white mr-1'\
              >\
              ครอบครัววัยรุ่น\
              </button>"
          }
          else if(cell.getValue() == "ครอบครัวผู้สูงอายุอยู่ด้วยกันตามลำพัง"){
            return "<button\
                class='btn btn-outline-secondary inline-block bg-white mr-1'\
              >\
              ครอบครัวผู้สูงอายุอยู่ด้วยกันตามลำพัง\
              </button>"
          }
          else if(cell.getValue() == "ครอบครัวคู่รักเพศเดียวกัน"){
            return "<button\
                class='btn btn-outline-secondary inline-block bg-white mr-1'\
              >\
              ครอบครัวคู่รักเพศเดียวกัน\
              </button>"
          }
          else if(cell.getValue() == "ครอบครัวผสม (ชายหญิงฝ่ายใดฝ่ายหนึ่งหรือทั้งสองฝ่าย มีบุตรติดมา)"){
            return "<button\
                class='btn btn-outline-secondary inline-block bg-white mr-1'\
              >\
              ครอบครัวผสม\
              </button>"
          }
          else if(cell.getValue() == "อยู่คนเดียว"){
            return "<button\
                class='btn btn-outline-secondary inline-block bg-white mr-1'\
              >\
              อยู่คนเดียว\
              </button>"
          }
          else{
            return "<button\
                class='btn btn-outline-secondary inline-block bg-white mr-1'\
              >\
              ครอบครัวขยาย\
              </button>"
          }
        }
      },
      {title:"จำนวนสมาชิก", field:"memberinfo", hozAlign:"center", resizable:true, minWidth: 200, mutator: customMemberCountMutator
      },
      // {
      //   title: 'ACTIONS',
      //   minWidth: 100,
      //   field: 'actions',
      //   hozAlign:"center",
      //   formatter(cell) {
      //       const a = cash(`<div class="flex lg:justify-center items-center h-full">
      //       <a class="flex items-center text-theme-24" href="javascript:;">
      //           <i data-feather="trash-2" class="w-4 h-4 mr-1"></i> ลบ
      //       </a>
      //       </div>`)
      //       cash(a).on('click', function(e) {
      //       e.stopPropagation();
      //           console.log("Do something", cell.getData()._id);
      //       // On click actions
      //       })
      //       return a[0]
      //   }
      // }
    ])

    return {
      dataArrayTable,
    }
  }
})
</script>

